module.exports = __webpack_public_path__ + "static/media/doc_seen.b31e1884.png";